import React, { Component } from "react";

import "./UiGiftCard.scss";

class UiCategoryCard extends Component {
  state = {
    activeSlide: 0,
  };

  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps, prevState) { }

  render() {
    return (
      <div className={"gift-card category-card" + (this.props.resized ? " resized" : "")+ (this.props.red ? " red" : "") } title={this.props.title} onClick={() => this.props.onClick()}>
        <div className="gift-card-image">
          <div className="gift-card-slider">
            <img src={this.props.image} alt={this.props.title} />
          </div>
        </div>
        <div className="gift-card-info">
          <p>{this.props.title}</p>
          <h3>{this.props.text}</h3>
        </div>
      </div>
    );
  }
}
export default UiCategoryCard;
